// extracted by mini-css-extract-plugin
module.exports = {"_heading":"Heading1__heading__1IiTp","flicker":"Heading1_flicker__2Cg2p"};